// CuruMatchDescription.js
import React from 'react';

export default function CuruMatchDescription ({ curuMatch })  {
    switch (true) {
        case curuMatch === 100:
            return <p>Boom! You and this product are a match made in heaven!</p>;
        case curuMatch >= 70:
            return <p>Solid Match! You and this product will get along just fine.</p>;
        case curuMatch >= 60:
            return <p>This could be something. More like friends, not besties.</p>;
        case curuMatch > 0:
            return <p>Hmm, not the best match. Let’s find something better.</p>;
        case curuMatch === 0:
            return <p>Oops, mismatch alert. Let's check out some other options!</p>;
        default:
            return <p>Match percentage is unavailable.</p>;
    }
};


